import moment from 'moment'

export default{

  props: {
    collapsed: Boolean,
    item: {
      type: Object,
      required: true,
    }
  },

  computed: {
    classObject() {
      const classes = []
      classes.push('task-'+this.item.duration)
      const today = moment(new Date).startOf('day')
      const past = moment(this.item.ends_at).startOf('day').diff(today, 'day') < 0
      const future = moment(this.item.starts_at).startOf('day').diff(today, 'day') > 0
      if(this.item.done || past) classes.push('done')
      else if(future) classes.push('future')
      if(this.collapsed) classes.push('collapsed')
      return classes
    },
  },

  mounted() {
    this.$el.item = this.item
  },
}